import React from 'react'
import styled from 'styled-components'

const StyledInput = styled.input<{ error?: boolean; fontSize?: string; align?: string }>`
  color: ${({ error, theme }) => (error ? theme.colors.failure : theme.colors.text)};
  width: 100%;
  position: relative;
  height: 46px;
  font-weight: 500;
  outline: none;
  border: 1px solid #D7CAEC;
  flex: 1 1 auto;
  background-color: #EEEAF4;
  font-size: 16px;
  text-align: ${({ align }) => align && align};
  white-space: nowrap;
  // overflow: hidden;
  // text-overflow: ellipsis;
  padding: 0 15px;
  border-radius: 16px;
  box-shadow: 0px 3px 5px 0px rgba(74,74,104,0.1) inset;
  -webkit-appearance: textfield;
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  [type='text'] {
    -moz-appearance: textfield;
  }

  ::-webkit-outer-spin-button,
  ::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ::placeholder {
    color: ${({ theme }) => theme.colors.textSubtle};
  }
`

export const Input = React.memo(function InnerInput({
  value,
  onUserInput,
  placeholder,
  ...rest
}: {
  value: string | number
  onUserInput: (input: string) => void
  error?: boolean
  fontSize?: string
  align?: 'right' | 'left'
} & Omit<React.HTMLProps<HTMLInputElement>, 'ref' | 'onChange' | 'as'>) {
 
  return (
    <StyledInput
      {...rest}
      value={value}
      onChange={(event) => {
        // replace commas with periods, because uniswap exclusively uses period as the decimal separator
        onUserInput(event.target.value.replace(/,/g, '.'))
      }}
      // universal input options
      inputMode="text"
      title="Token Amount"
      autoComplete="off"
      autoCorrect="off"
      // text-specific options
      type="text"
      placeholder={placeholder || ''}
      minLength={1}
      maxLength={79}
      spellCheck="false"
    />
  )
})

export default Input
